import { Link } from "react-router-dom";
import { ArrowLeft, ShieldAlert, ExternalLink, Lock } from "lucide-react";

export function Whistleblowing() {
    return (
        <div className="container py-12 md:py-16">
            <Link to="/" className="inline-flex items-center text-text-body hover:text-brand-primary mb-8 transition-colors">
                <ArrowLeft className="h-4 w-4 mr-2" /> Torna alla Home
            </Link>
            
            <div className="max-w-4xl mx-auto">
                <div className="flex items-center gap-4 mb-8">
                    <ShieldAlert className="h-10 w-10 text-brand-primary" />
                    <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-title">Whistleblowing</h1>
                </div>
                
                <div className="prose prose-lg text-text-body max-w-none mb-10">
                    <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg mb-8">
                        <p className="mb-0 font-medium">
                            A seguito dell’entrata in vigore del Decreto Legislativo 24/2023 del 10 marzo 2023 - Attuazione della direttiva (UE) 2019/1937, riguardante la protezione delle persone che segnalano violazioni del diritto dell’Unione e delle disposizioni normative nazionali, la Società ha adottato il seguente canale interno per effettuare le segnalazioni.
                        </p>
                    </div>

                    <h2 className="text-2xl font-bold text-text-title mb-4">Canale di Segnalazione</h2>
                    
                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-8">
                        <p className="mb-4">
                            Per effettuare una segnalazione sicura e riservata, utilizza il portale dedicato del Gruppo Sapio:
                        </p>
                        <a 
                            href="https://segnalazioni.net/grupposapio" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="inline-flex items-center px-6 py-3 bg-brand-primary text-white font-medium rounded-lg hover:bg-brand-secondary transition-colors shadow-md"
                        >
                            <ExternalLink className="h-5 w-5 mr-2" />
                            Accedi al portale Segnalazioni
                        </a>
                        <p className="text-sm text-gray-500 mt-2">
                            Link esterno: Gruppo Sapio - Segnalazione Illeciti (segnalazioni.net)
                        </p>
                    </div>

                    <h2 className="text-2xl font-bold text-text-title mb-4">Le novità della nuova normativa</h2>
                    
                    <div className="grid md:grid-cols-2 gap-6 mb-8">
                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                            <div className="flex items-center mb-3 text-brand-primary">
                                <Lock className="h-6 w-6 mr-2" />
                                <h3 className="text-xl font-bold">Sicurezza Garantita</h3>
                            </div>
                            <p>
                                Se sei un dipendente di Puglia Life srl e hai delle segnalazioni da fare, ora puoi farlo in tutta sicurezza grazie alla nuova normativa sul whistleblowing.
                            </p>
                        </div>
                        
                        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
                            <div className="flex items-center mb-3 text-brand-primary">
                                <ShieldAlert className="h-6 w-6 mr-2" />
                                <h3 className="text-xl font-bold">Protezione Totale</h3>
                            </div>
                            <p>
                                Questa legge ti protegge se denunci comportamenti illeciti o irregolarità all'interno dell'azienda, garantendo i tuoi diritti e definendo le responsabilità.
                            </p>
                        </div>
                    </div>

                    <div className="mb-8">
                        <h2 className="text-2xl font-bold text-text-title mb-4">Video Informativo</h2>
                        <div className="rounded-xl overflow-hidden shadow-lg border border-gray-100 bg-black">
                            <video 
                                controls 
                                className="w-full h-auto"
                                width="100%"
                            >
                                <source src="/video/27_Whistleblowing--002-.mp4" type="video/mp4" />
                                Il tuo browser non supporta il tag video.
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
